import React, {Component} from 'react';
import {scrollToOffset} from "../../utils";
import './styles.css';

/**
 * ScrollTop
 */
class ScrollTop extends Component {
  constructor(props) {
    super();
    this.props = props;
    this.state = {
      open: false,
    };
    this.isOpen = false;
  }
  
  componentDidMount() {
    window.addEventListener('scroll', this.handleScroll);
  }
  
  componentWillUnmount() {
    window.removeEventListener('scroll', this.handleScroll);
  }
  
  render() {
    const open = (this.state.open === true) ? ' open': '';
    return (
      <a className={'ScrollTop' + open}
         href="#"
         onClick={(e) => {
           this.handleClick(e)
         }}
      >
        {'ScrollTop'}
      </a>
    )
  }
  
  //
  handleScroll = () => {
    //const top = document.documentElement.scrollTop;
    const top = window.pageYOffset;
    if (top < 100) {
      if (this.isOpen === false) return;
      this.isOpen = false;
      this.setState({
        open: false,
      });
    } else {
      if (this.isOpen === true) return;
      this.isOpen = true;
      this.setState({
        open: true,
      });
    }
  };
  
  //
  handleClick = (e) => {
    e.preventDefault();
    //
    scrollToOffset(0);
  };
  
}

export default ScrollTop;



// WEBPACK FOOTER //
// ./src/components/scroll-top/index.jsx